import Link from "next/link";
import NextImage from "next/image";
import MarketScheduleEventCard from "./event-card";

function EventSection({ title, events }) {
  if (!events.length) {
    return null;
  }

  return (
    <section className="mt-10">
      <h2 className="font-[Staatliches] text-3xl tracking-wide text-chocolate">{title}</h2>
      <div className="mt-4 grid gap-4 md:grid-cols-2">
        {events.map((event) => (
          <MarketScheduleEventCard event={event} key={`${event.eventId}-${event.eventDayId}`} />
        ))}
      </div>
    </section>
  );
}

export default function MarketSchedulePageContent({ events }) {
  const scheduleEvents = Array.isArray(events) ? events : [];

  return (
    <div className="px-4 py-4 sm:px-6 lg:px-8">
      <header className="border-b border-chocolate/15 pb-8">
        <p className="text-sm font-bold uppercase tracking-[0.18em] text-crimson">Markets and pop-ups</p>
        <h1 className="mt-3 font-[Staatliches] text-3xl leading-none tracking-wide text-chocolate sm:text-6xl">
          Find Goldmallow in person at Seattle-area events.
        </h1>
        <p className="mt-4 max-w-2xl text-base font-medium leading-7 text-chocolate/80">
          Catch us at Seattle-area markets, festivals, expos, and neighborhood pop-ups.
        </p>
      </header>
      <NextImage src="https://storage.googleapis.com/application_content/Market_Booth_6e3908376d/Market_Booth_6e3908376d.jpg" alt="Market Booth" width={360} height={0} className="mx-auto mt-6 rounded-lg shadow-lg" />

      {scheduleEvents.length ? (
        <EventSection title="Upcoming Pop-Ups & Events" events={scheduleEvents} />
      ) : (
        <section className="mt-10 rounded-lg border border-dashed border-chocolate/25 bg-white/75 px-6 py-10 text-center">
          <h2 className="text-2xl font-bold text-chocolate">No upcoming markets are posted right now.</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm font-medium leading-6 text-chocolate/75">
            Check back soon or shop online while the next market date is being finalized.
          </p>
          <Link
            className="mt-6 inline-flex min-h-11 items-center justify-center rounded-lg bg-crimson px-5 py-3 text-sm font-bold text-white transition hover:brightness-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-crimson/40 focus-visible:ring-offset-2"
            href="/store"
          >
            Shop online
          </Link>
        </section>
      )}
    </div>
  );
}
